import { jsx as _jsx } from "react/jsx-runtime";
import { useVerticalExternalTimelineProcessController, } from "../../useVerticalTimelineProcessController";
import { TimelineDotDefault, TimelineDotError, TimelineDotSuccess, } from "./TimelineDots";
export function StatusTimelineDotExam(_a) {
    var data = _a.data, step = _a.step;
    var _b = useVerticalExternalTimelineProcessController({
        data: data,
    }), isDateBeforeSecondDate = _b.isDateBeforeSecondDate, findExamResult = _b.findExamResult;
    var examResult = findExamResult(step.key);
    var isApto = (examResult === null || examResult === void 0 ? void 0 : examResult.resultado) === "Apto";
    var isRecentExam = isDateBeforeSecondDate(data.dataProcesso, examResult === null || examResult === void 0 ? void 0 : examResult.data);
    if (!isRecentExam) {
        return _jsx(TimelineDotDefault, {});
    }
    else {
        return isApto ? _jsx(TimelineDotSuccess, {}) : _jsx(TimelineDotError, {});
    }
}
